(function () {
  'use strict';
  if (window.ftcHeroSliderReady) return;
  window.ftcHeroSliderReady = true;
  var controllers = new Map();
  function init(section) {
    if (controllers.has(section)) return;
    var slides = section.querySelectorAll('[data-slider-slide]');
    var dots = section.querySelectorAll('[data-slider-dot]');
    if (!slides.length) return;
    var current = 0;
    var timer = null;
    var hovered = false;
    var focused = false;
    var interval = Math.max(3000, Number(section.dataset.interval) || 10000);
    function stop() {
      if (timer !== null) clearInterval(timer);
      timer = null;
    }
    function start() {
      if (timer !== null || document.hidden || hovered || focused || section.dataset.autoplay !== 'true' || slides.length < 2) return;
      timer = setInterval(function () { go(current + 1); }, interval);
    }
    function go(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, i) { slide.classList.toggle('is-active', i === current); });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === current);
        dot.setAttribute('aria-current', i === current ? 'true' : 'false');
      });
    }
    function restart() { stop(); start(); }
    section.addEventListener('click', function (event) {
      var button = event.target.closest('[data-slider-prev], [data-slider-next], [data-slider-dot]');
      if (!button || !section.contains(button)) return;
      if (button.hasAttribute('data-slider-dot')) go(Number(button.dataset.sliderDot));
      else go(current + (button.hasAttribute('data-slider-next') ? 1 : -1));
      restart();
    });
    section.addEventListener('mouseenter', function () { hovered = true; stop(); });
    section.addEventListener('mouseleave', function () { hovered = false; start(); });
    section.addEventListener('focusin', function () { focused = true; stop(); });
    section.addEventListener('focusout', function (event) {
      if (!section.contains(event.relatedTarget)) { focused = false; start(); }
    });
    controllers.set(section, { stop: stop, start: start });
    go(0);
    start();
  }
  function initAll(root) {
    if (root.matches && root.matches('[data-ftc-hero-slider]')) init(root);
    root.querySelectorAll('[data-ftc-hero-slider]').forEach(init);
  }
  initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    controllers.forEach(function (controller, section) {
      if (event.target.contains(section)) { controller.stop(); controllers.delete(section); }
    });
  });
  document.addEventListener('visibilitychange', function () {
    controllers.forEach(function (controller) { if (document.hidden) controller.stop(); else controller.start(); });
  });
})();
